/**
 * Sign-off celebration toast, lifted from pages/AccountantQueue.tsx so it can
 * live on the parent dashboard and survive tab switches.
 */
import React, { useEffect } from 'react';
import { CheckCircle2 } from 'lucide-react';

interface Props {
  show: boolean;
  businessName: string;
  onClose: () => void;
}

export default function SignOffToast({ show, businessName, onClose }: Props) {
  useEffect(() => {
    if (show) {
      const timer = setTimeout(onClose, 4000);
      return () => clearTimeout(timer);
    }
  }, [show, onClose]);

  if (!show) return null;

  return (
    <div className="fixed bottom-6 right-6 z-50 animate-bounce-once">
      <div className="text-white px-6 py-4 rounded-xl shadow-2xl flex items-center gap-4 max-w-md" style={{ backgroundColor: 'var(--color-verified)' }}>
        <CheckCircle2 className="w-10 h-10 text-white flex-shrink-0" />
        <div>
          <div className="font-semibold text-lg">Case Signed Off!</div>
          <div className="text-sm" style={{ color: '#ffffff', opacity: 0.85 }}>{businessName} is ready for delivery</div>
        </div>
        <button
          onClick={onClose}
          className="ml-2 text-white"
          aria-label="Dismiss notification"
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
    </div>
  );
}
